module.exports = __webpack_public_path__ + "img/updateDescriptionImage.a8135a4a.png";